<template>
  <div class="container mx-auto my-8 px-4 lg:px-0">

    <div class="mb-8 flex justify-between items-center">
      <search-input
        class="w-full lg:max-w-sm shadow"
        placeholder="Zoeken op naam.."
        @searched="onSearched">
      </search-input>
    </div>

    <div class="bg-white shadow overflow-x-auto">
      <table class="custom w-full whitespace-no-wrap">
        <thead>
          <tr class="text-left text-green-darker">
            <th class="px-6">Naam</th>
            <th class="px-6">Gemaakt op</th>
            <th class="px-6">Gewijzigd op</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="investigator in investigators.data" :key="investigator.id" class="hover:bg-grey-lightest text-grey-darker">
            <td class="border-t border-grey-lighter px-6 py-4">
                {{ investigator.name }}
            </td>
            <td class="border-t border-grey-lighter px-6 py-4">
                {{ investigator.created_at }}
            </td>
            <td class="border-t border-grey-lighter px-6 py-4">
                {{ investigator.updated_at }}
            </td>
          </tr>
          <tr v-if="investigators.data && investigators.data.length === 0">
            <td class="border-t border-grey-lighter px-6 py-4" colspan="3">Geen onderzoekers gevonden.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <base-pagination
      class="mt-2"
      v-if="investigators.meta && investigators.meta.last_page > 1"
      :total-pages="investigators.meta.last_page"
      :total="10"
      :current-page="investigators.meta.current_page"
      @page-changed="onPageChanged">
    </base-pagination>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import SearchInput from '@/components/inputs/Search';

export default {
  name: 'investigators',
  components: {
    SearchInput
  },
  created() {
    this.fetch(this.$route.query.page);
  },
  data() {
    return {
      investigators: {}
    };
  },
  methods: {
    fetch(page = 1) {
      let params = { page: page, sort: 'name' };

      ApiService.query('/v1/investigators', { params: params }).then(
        response => (this.investigators = response.data)
      );
    },
    onPageChanged(page) {
      this.$router.push({ name: 'investigators', query: { page: page } });
    },
    onSearched(keyword) {
      if (!keyword) {
        return this.fetch();
      }

      ApiService.get(
        '/v1/investigators',
        `search?filter[name]=${keyword}`
      ).then(response => (this.investigators = response.data));
    }
  }
};
</script>
